import React, { forwardRef } from 'react'
import { MarketCalculusCard } from '../../components/preview/Preview'
import SummarySection from '../mc-components/summary-tables/SummarySection'
import CONSTANTS from '../../utils/Constants'
import { useRAWcomtradeSummary } from '../../store/rawStore'
import { useDSsummaryTablesData } from '../../store/dataStore'

const SourceCountrySummaryTab = forwardRef(({
  isMonthly,
  summaryViewSearchHandlerRef,
  tableImportMonthRef,
  tableImportYearRef
}, ref) => {
  const comtradeSummary = useRAWcomtradeSummary()
  const summaryTablesData = useDSsummaryTablesData()

  return (
    <>
      {isMonthly.importer
        ? <MarketCalculusCard className={!comtradeSummary?.importerMonthly?.length ? 'loading-div' : ''}>
          <SummarySection
            ref={tableImportMonthRef}
            data={summaryTablesData?.import?.monthly}
            date={summaryTablesData?.import?.month}
            titleKey={'st_month_importer'}
            graphCode={CONSTANTS.BADGE_CODES.SUMMARY_TABLES_TABLE_2.replace('T-', 'H-')}
            code={CONSTANTS.BADGE_CODES.SUMMARY_TABLES_TABLE_2}
            isWorld={false}
            isYearly={false}
            isImport={true}
            explanation={summaryTablesData?.import?.monthlyExplanation}
            onTableRowClick={summaryViewSearchHandlerRef?.current?.onTableRowClick}
          />
        </MarketCalculusCard>
        : <MarketCalculusCard className={!comtradeSummary?.importerYearly?.length ? 'loading-div' : ''}>
          <SummarySection
            ref={tableImportYearRef}
            data={summaryTablesData?.import?.yearly}
            date={summaryTablesData?.import?.year}
            titleKey={'st_year_importer'}
            graphCode={CONSTANTS.BADGE_CODES.SUMMARY_TABLES_TABLE_1.replace('T-', 'H-')}
            code={CONSTANTS.BADGE_CODES.SUMMARY_TABLES_TABLE_1}
            isWorld={false}
            isYearly={true}
            isImport={true}
            explanation={summaryTablesData?.import?.yearlyExplanation}
            onTableRowClick={summaryViewSearchHandlerRef?.current?.onTableRowClick}
          />
        </MarketCalculusCard>
      }
    </>
  )
})

export default SourceCountrySummaryTab
